module.exports = __webpack_public_path__ + "img/faq_bg.22e18fec.png";